import { setGetListLotteryAction } from '../action';
import { getListLottery } from '../api/getListLottery';

const setGetListLottery = (params) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await getListLottery(params);

            if (data.status === 'success') {
                dispatch(setGetListLotteryAction({
                    data: data.data,
                    page: data.countPage,
                }));
            }

        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setGetListLottery
}